import type { DanmakuItem } from "@/types/live";

export const danmakuPool: DanmakuItem[] = [
  { id: "d1", user: "路过的小梨", text: "主播今天状态太好了！", color: "text-primary-300" },
  { id: "d2", user: "夜风轻语", text: "前排打卡，画质好清晰", color: "text-accent-300" },
  { id: "d3", user: "不吃香菜", text: "哈哈哈哈笑死我了", color: "text-background-50" },
  { id: "d4", user: "像素旅人", text: "这个操作也太秀了吧", color: "text-secondary-300" },
  { id: "d5", user: "柠檬汽水", text: "已点赞，支持主播", color: "text-primary-300" },
  { id: "d6", user: "山海来信", text: "第一次来，感觉好温暖", color: "text-background-50" },
  { id: "d7", user: "一只汤圆", text: "求点一首歌！", color: "text-accent-300" },
  { id: "d8", user: "晚风和你", text: "背景音乐好好听", color: "text-background-50" },
  { id: "d9", user: "雾里看花", text: "主播声音好治愈", color: "text-secondary-300" },
  { id: "d10", user: "远方旅人", text: "收藏了，明天还来", color: "text-primary-300" },
  { id: "d11", user: "慢半拍", text: "这波节奏很舒服", color: "text-background-50" },
  { id: "d12", user: "小满时节", text: "分享了给朋友一起看", color: "text-accent-300" },
];